import { HttpServiceBase } from "./http-service-base";
import * as env from "../../config/environment.json";
import { b64decode, isGuid, convertGuidsToBase64 } from "../b64";

export class FormSignService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }

  version = "v1";

  async get(formSignId) {
    console.log("get", formSignId)
    const data = await this.http.get(`${this.version}/formsign/${formSignId}`);
    return JSON.parse(data.response);
  }

  async getByReferenceId(referenceId, signerEmail) {
    console.log("getByReferenceId", referenceId, signerEmail)
    // Omit the email filter when we have no address. The signature lives on FormSign
    // even when the form field holding the email was never saved on the report.
    const email = signerEmail ? `&email=${encodeURIComponent(signerEmail)}` : "";
    const data = await this.http.get(`${this.version}/formsign?referenceId=${referenceId}${email}`);
    return JSON.parse(data.response);
  }
  async getData(formSignId){
    console.log("getData", formSignId)
    const data = await this.http.get(`${this.version}/formsigndata/${formSignId}`);
    return JSON.parse(data.response);
  }

  async list() {
    const data = await this.http.get(`${this.version}/formsign`);
    return JSON.parse(data.response);
  }

  async requestSignature(formSignId, referenceId, referenceType, referenceNumber, referenceDescription, signerEmail, data, signDescription) {
    const message = await this.http.post(`${this.version}/formsign/request`, {
      formSignId,
      referenceId: referenceId,
      referenceType: referenceType,
      referenceNumber: referenceNumber,
      referenceDescription: referenceDescription,
      signerEmail: signerEmail,
      data, //array with objects like {name(string), value(string), sortOrder(int)}
      LanguageKey: "sv", //todo: get from
      signDescription
    });
    return JSON.parse(message.response);
  }

  async withdraw(formSignId) {
    const message = await this.http.post(`${this.version}/formsign/${formSignId}/withdraw`);
    return JSON.parse(message.response);
  }

  async sign(formSignId, signerUserId, data) {
    await this.http.post(`${this.version}/formsign/${formSignId}/sign`, {
      formSignId,
      signerUserId,
      signerName: data ? data.fullName : null,
      signed: data ? data.updated : null,
      signatureReferenceId: data ? data.bankIdOrderRef : null
    });
  }
}
